var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "map uk-position-relative" },
      [
        _c("div", {
          staticClass: "map__container",
          attrs: { id: "hazardmap" }
        }),
        _c("vue-hazardmap-header-component"),
        _c("vue-hazardmap-message-component"),
        _c("vue-hazardmap-guide-component"),
        _c("vue-hazardmap-memo-for-printer-component"),
        _c("vue-hazardmap-kikikuru-component"),
        _c("vue-hazardmap-offcanvas-component"),
        _c("vue-hazardmap-attribution-component")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }